<article
  class="candidate-card"
  [class.is-blank-vote-option]="candidate.isBlankVoteOption"
  [class.is-selected]="selected"
  [class.is-disabled]="disabled"
  [class.is-clickable]="selectionMode"
  (click)="handleClick()">
  @if (shouldShowSelectionCheck) {
    <span class="candidate-check candidate-check--floating">
      <i class="fa fa-check" aria-hidden="true"></i>
    </span>
  } @else if (shouldShowStatusBadge) {
    <span class="candidate-status-badge" [class.is-elected]="!candidate.isElectionActive && candidate.isElected">
      {{ statusBadgeLabel }}
    </span>
  }

  <div class="candidate-card-top">
    <div class="candidate-avatar" [class.is-photo]="candidate.photoUrl">
      @if (candidate.photoUrl) {
        <img [src]="candidate.photoUrl" [alt]="'Foto de ' + candidate.name">
      } @else {
        <span>{{ getCandidateInitials() }}</span>
      }
    </div>

    <div class="candidate-meta">
      <span class="candidate-number">{{ cardEyebrow }}</span>
      <span class="candidate-department">{{ metaLine }}</span>
    </div>
  </div>

  <div class="candidate-card-body">
    <h3>{{ candidate.name }}</h3>
    @if (shouldShowPosition) {
      <span class="candidate-position">{{ candidate.position }}</span>
    }
    @if (candidate.slogan) {
      <p>{{ candidate.slogan }}</p>
    }
    @if (footerText) {
      <small>{{ footerText }}</small>
    }
  </div>
</article>
